<script>

export default {
  name: 'UlFormItemGender',
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
};
</script>
<template>
  <UlFormGender
    v-model="module.value"
    :disabled="module.disabled"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
  >
    <slot></slot>
  </UlFormGender>
</template>
